/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";
import Section from "../Section/Section";
import Video from "../Video/Video";

export default function BrandVideos({ brand, ...rest }) {
  if (!hasContent(brand)) return null;
  const needsTitle = !brand.videos[0]?.title;
  return (
    <Section title={needsTitle && <Trans>Videos</Trans>} {...rest}>
      {brand.videos.map((video) => (
        <Video key={video?.videoId} {...video} />
      ))}
    </Section>
  );
}
BrandVideos.hasContent = hasContent;
function hasContent(brand) {
  if (!brand?.videos?.length) return false;
  return brand.videos.some((video) => Video.hasContent(video));
}

export const fragment = graphql(`
  fragment BrandVideos_Profile on Bottlebooks_Profile {
    ... on Bottlebooks_BrandProfile {
      videos {
        type
        videoId
        title
        ...bb_Video
      }
    }
  }
  fragment BrandVideos on Bottlebooks_AbstractBrand {
    ... on Bottlebooks_Exhibitor {
      videos {
        type
        videoId
        title
        ...bb_Video
      }
    }
    ... on Bottlebooks_Producer {
      videos {
        type
        videoId
        title
        ...bb_Video
      }
    }
  }
`);

export const BrandVideosFragment = gql`
  fragment BrandVideos on AbstractBrand {
    ... on Exhibitor {
      videos {
        type
        videoId
        title
        ...Video
      }
    }
    ... on Producer {
      videos {
        type
        videoId
        title
        ...Video
      }
    }
  }

  ${Video.fragment}
`;
